<template>
  <div class="navbar-area">
    <div class="luvion-responsive-nav">
      <div class="container">
        <div class="luvion-responsive-menu">
          <div class="logo">
            <router-link to="/">
              <img src="assets/img/logo.png" alt="logo" />
              <img src="assets/img/black-logo.png" alt="logo" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="luvion-nav">
      <div class="container">
        <nav class="navbar navbar-expand-md navbar-light">
          <a class="navbar-brand" href="#home">
            <img class="black-img" src="assets/img/logo.png" alt="logo" />
            <img src="assets/img/black-logo.png" alt="logo" />
          </a>
          <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
            <ul class="navbar-nav">
              <li class="nav-item">
                <a href="#home" class="nav-link">Home</a>
              </li>
              <li class="nav-item">
                <a href="#services" class="nav-link">
                  Services
                  <i class="fas fa-chevron-down"></i>
                </a>
                <ul class="dropdown-menu">
                  <li class="nav-item">
                    <a href="#ussd_payment" class="nav-link">USSD payment</a>
                  </li>

                  <li class="nav-item">
                    <a href="#bank_transfer" class="nav-link">Bank Transfer</a>
                  </li>

                  <li class="nav-item">
                    <a href="#ussd_cashout" class="nav-link">USSD Cashout</a>
                  </li>

                  <li class="nav-item">
                    <a href="#corporate_payment" class="nav-link">Corporate Payment</a>
                  </li>

                  <li class="nav-item">
                    <a href="#adept" class="nav-link">Adept</a>
                  </li>
                </ul>
              </li>
              <li class="nav-item">
                <a href="#features" class="nav-link">Features</a>
              </li>

              <li class="nav-item">
                <a href="#channels" class="nav-link">Channels</a>
              </li>
              <li class="nav-item">
                <a href="#blog" class="nav-link">Blog</a>
              </li>
              

              
              <li class="nav-item">
                <a href="#aboutUs" class="nav-link">About Us

                  <i class="fas fa-chevron-down"></i>
                </a>
                
                 <ul class="dropdown-menu">
                 <li class="nav-item">
                <a href="#contact" class="nav-link">Contact Us</a>
              </li>

                  <li class="nav-item">
                    <a href="#partners" class="nav-link">Our Partners</a>
                  </li>

                  <li class="nav-item">
                    <a href="#aboutUs" class="nav-link">Feedbacks</a>
                  </li>

                  
                </ul>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.logo-img {
  padding: 10px;
}
</style>